import { useData } from "../../../runtime/provider";
import ImagePicker from "@components/ImagePicker";
import LBox from "@components/LBox";
import LButton from "@components/LButton";
import LScreen from "@components/LScreen";
import { router } from "expo-router";
import React from "react";
import { Platform, ScrollView } from "react-native";
import { useManagedArtists } from "@hooks/trpc/useManagedArtists";
import { uploadImage } from "@components/Account/Profile/profile.utils";
import { isProdEnv } from "@utils/envs";
import LText from "@components/LText";
import { useUpdateArtist } from "@hooks/trpc/useManagedArtists";
import { toast } from "sonner-native";
export const ArtistProfileScreen = () => {
  const session = useData();
  const scrollViewRef = React.useRef<ScrollView>(null);
  const {
    artists: { data: artists },
  } = useManagedArtists();

  const updateArtist = useUpdateArtist();

  const artist = artists?.at(0);

  const [localImage, setLocalImage] = React.useState<{
    type: any;
    uri: string;
    base64?: string | null;
    mimeType?: string | null;
  }>();

  const isProd = isProdEnv();

  if (!artist) {
    return null;
  }

  const isValid = !!localImage;
  return (
    <LScreen
      enableAutomaticBottomPadding={true}
      enableAutomaticTopPadding={true}
      keyboard
      paddingTop={Platform.OS === "android" ? "l3" : "m2"}
      safeArea
      safeAreaEdges={["top", "bottom"]}
    >
      <ScrollView
        contentContainerStyle={{ flexGrow: 1 }}
        ref={scrollViewRef}
        onContentSizeChange={() => scrollViewRef.current?.scrollToEnd()}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
      >
        <LBox flexGrow={1}>
          <LBox mb="s4">
            <LBox mb="l1">
              <ImagePicker
                disabled={!isProd}
                title=""
                avatar
                allowsEditing={false}
                imageUrl={localImage?.uri ?? artist?.image}
                onPick={({ uri, type, base64, mimeType }) => {
                  setLocalImage({
                    uri,
                    type,
                    base64,
                    mimeType,
                  });
                }}
                border
              />
            </LBox>
            {!isProd ? (
              <LText textAlign="center">
                This is disabled in non prod environments
              </LText>
            ) : null}
          </LBox>
        </LBox>
        <LBox
          flexGrow={1}
          justifyContent="flex-end"
          paddingBottom={Platform.OS === "android" ? "m1" : "zero"}
        >
          <LButton
            sentryEventName="profile_save_changes"
            variant="primary"
            textVariant="bodyM2Transparent"
            height={46}
            borderRadius="max"
            onPress={async () => {
              try {
                if (!localImage) {
                  return;
                }
                const imageUrl = await uploadImage(session, {
                  uri: localImage.uri,
                  contentType: localImage.mimeType,
                });

                await updateArtist.mutateAsync({
                  imageUrl,
                  artistId: artist.id,
                });
                toast.success("Profile updated");
                router.back();
              } catch (error) {
                console.log(error);
                router.back();
                toast.error("Something went wrong");
              }
            }}
            enabled={isValid}
            label="SAVE CHANGES"
          />
        </LBox>
      </ScrollView>
    </LScreen>
  );
};
